import {i18n} from '@wendig/lib'
import config from '../lib/dotenv'
import {baseUrl} from '../lib/util'
import search from './search.instance'

export default class Article {
  constructor(data) {
    this.d = data
  }

  load() {
    if (!this.promise) {
      this.promise = search.article(this.id()).then(data => {
        this.d = data
      })
    }

    return this.promise
  }

  isOpen() {
    return !!this.openState
  }

  open() {
    this.openState = true
  }

  close() {
    this.openState = false
  }

  id() {
    return this.d['ID']
  }

  title() {
    return this.d['Titel']
  }

  date() {
    return `${this.d['day']}.${this.d['month']}.${this.d['year']}`
  }

  page() {
    return this.d['Seite']
  }

  comment() {
    return this.d['Bemerkungen']
  }

  categories() {
    return this.d['Themen']
  }

  people() {
    return this.d['Personen']
  }

  locations() {
    return this.d['Orte']
  }

  structure() {
    return this.d['Strukt']
  }

  journal() {
    return this.d['Zeitungsname']
  }

  issue() {
    return this.d['ZAusgabe']
  }

  imageUrl() {
    const base = 'http://www.hait.tu-dresden.de/slub'
    const year = this.d['year']
    const month = String(this.d['month']).padStart(2, '0')
    const day = String(this.d['day']).padStart(2, '0')
    const page = String(this.page()).padStart(8, '0')

    return `${base}/${year}/${month}/files/${day}/files/${page}.tif.large.jpg`
  }

  slubUrl() {
    const slubMap = {
      1930: 5655,
      1931: 5655,
      1933: 7860,
      1934: 7860,
      1935: 8867,
      1936: 8867,
      1937: 8867,
      1938: 8867,
      1939: 8867,
      1940: 8867,
      1941: 8867,
      1942: 8867,
      1943: 8867,
      1944: 8867,
      1945: 8867
    }

    const year = this.d['year']
    let slubId = slubMap[year]
    const month = this.d['month']
    if (year == 1932) {
      slubId = (month >= 2 ? 5655 : 7860)
    }
    const day = this.d['day']
    const date = [
      String(year).padStart(4, '0'),
      String(month).padStart(2, '0'),
      String(day).padStart(2, '0')
    ].join('')
    const base = 'http://digital.slub-dresden.de'

    return `${base}/id41717${slubId}-${date}/${this.page()}`
  }
}
